export default "__VITE_ASSET__953e24df__"